import React, { useState } from "react";
import { useEffect } from "react";
import { db } from "../firebase-config";
import { collection, getDocs, updateDoc, doc, where, query, orderBy } from "firebase/firestore"
import Papa from "papaparse";
import foursomeTableImage from "../foursomestable.png"

  
const StayAndPlay = () => {

  const usersCollectionRef = collection(db, "users")
  const [usersList, setUsersList] = useState([]);
  const [events, setEvents] = useState([]);
  const eventsCollectionRef = collection(db, "StayAndPlay");
  const [inputName, setInputName] = useState("");
  const [waitingName, setWaitingName] = useState("")
  let eventTime;
  const startOfDay = new Date();
  startOfDay.setUTCHours(0,0,0,0);
  let nameCheck="";
  let nameSwitch=false;
  const bannerCollectionRef = collection(db, "Banner");
  const [bannerData, setBannerData] = useState([]);

  // let eventSpreadSheet1;
  // const [sheet1Data, setSheet1Data] = useState([]);
  // const getSheet1Data = async () =>{
  //   Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vR103Lni1HiOZgtexqJL4I12qlbbcd86P7IEM2BROVLVFgzzc-NX6cgZa7_L7dKeg/pub?gid=1860548921&single=true&output=csv", {
  //     download: true,
  //     header: true,
  //     complete: (results) => {
  
  //       setSheet1Data(results.data.slice(3,23))
  //     },
  //   });
  // }

  //   useEffect(() =>{
  //     getSheet1Data();
  //     console.log("get sheets ran")
  //   }, []);

  // let eventSpreadSheet2;
  // const [sheet2Data, setSheet2Data] = useState([""]);
  // const getSheet2Data = async () =>{
  //   Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vR103Lni1HiOZgtexqJL4I12qlbbcd86P7IEM2BROVLVFgzzc-NX6cgZa7_L7dKeg/pub?gid=1860548921&single=true&output=csv", {
  //     download: true,
  //     header: true,
  //     complete: (results) => {
  
  //       setSheet2Data(results.data.slice(2,19))
  //     },
  //   });
  // }

  //   useEffect(() =>{
  //     getSheet2Data();
  //     console.log("get sheets ran")
  //   }, []);

  // let eventSpreadSheet3;
  // const [sheet3Data, setSheet3Data] = useState([]);
  // const getSheet3Data = async () =>{
  //   Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vR103Lni1HiOZgtexqJL4I12qlbbcd86P7IEM2BROVLVFgzzc-NX6cgZa7_L7dKeg/pub?gid=1731747533&single=true&output=csv", {
  //     download: true,
  //     header: true,
  //     complete: (results) => {
  
  //       setSheet3Data(results.data.slice(28,48))
  //     },
  //   });
  // }

    // useEffect(() =>{
    //   getSheet3Data();
    //   console.log("get sheets ran")
    // }, []);  
  

  useEffect(() =>{
    const getBanner = async () => {
      const qb = query(bannerCollectionRef);
      const banners = await getDocs(qb);
      setBannerData(banners.docs.map((doc) => ({...doc.data(), id: doc.id})))
    }

    getBanner().then(function(){
      console.log("get banner ran");
      console.log(bannerData);
    })

  }, []);

  useEffect(() =>{
    const getUsers = async () => {
      const qw = query(usersCollectionRef, orderBy("name", "asc"));
      const dbUsers = await getDocs(qw);
      setUsersList(dbUsers.docs.map((doc) =>({...doc.data()})))
    }

    getUsers();
  }, [])
  
  useEffect(() =>{

    const getEvents = async () =>{
      const q = query(eventsCollectionRef, where("Date", ">", startOfDay), orderBy("Date", "asc"));
      const newData = await getDocs(q);
      setEvents(newData.docs.map((doc) =>({...doc.data(), id: doc.id})));
    }; 
 

    getEvents().then(function(){
      console.log("get events function done")
    }); 

  }, []);

  const checkForAdd = async (id, index) =>{
    let tempData=[];
    const getEvents = async () =>{
      const q = query(eventsCollectionRef, where("Date", ">", startOfDay), orderBy("Date", "asc"));
      const newData = await getDocs(q);
      setEvents(newData.docs.map((doc) =>({...doc.data(), id: doc.id})));
      tempData=newData.docs.map((doc) =>({...doc.data(), id: doc.id}));
      addParticipant(id, tempData[index].Attendees, index)
    }; 
    getEvents()
  }

  const checkForWaiting = async (id, index) =>{
    let tempData=[];
    const getEvents = async () =>{
      const q = query(eventsCollectionRef, where("Date", ">", startOfDay), orderBy("Date", "asc"));
      const newData = await getDocs(q);
      setEvents(newData.docs.map((doc) =>({...doc.data(), id: doc.id})));
      tempData=newData.docs.map((doc) =>({...doc.data(), id: doc.id}));
      addWaitingList(id, tempData[index].Attendees, tempData[index].Waiting)
    }; 
    getEvents()
  }

  const addWaitingList = async (id, Attendees, Waiting) =>{
    const eventDoc = doc(db, "StayAndPlay", id)
    let shownName=""
    if (Attendees.length)
    if(inputName === ""){
      console.log("Error, no Input");
      document.getElementById(id+"text").style.display = "block";
    }else{
      for(let i=0; i<usersList.length; i++){
        nameCheck = usersList[i].email;
        if(nameCheck === inputName.toLowerCase()){
          console.log("yes, name is " + usersList[i].name);
          nameSwitch=true;
          shownName= usersList[i].name;
        }
      }
      if(!Attendees.includes(shownName) && !Waiting.includes(shownName)){
        if(nameSwitch===true){
          const newWaiting = {Waiting: [...Waiting, shownName]}
          await updateDoc(eventDoc, newWaiting);
          console.log("no error")
          document.getElementById(id+"text").style.display = "none";
          document.getElementById(id+"error").style.display = "none";
          document.getElementById(id+"duplicate").style.display = "none";
          document.getElementById(id+"success").style.display = "block";
          document.getElementById(id+"input").value = "";
          const getEvents = async () =>{
            const q = query(eventsCollectionRef, where("Date", ">", startOfDay), orderBy("Date", "asc"));
            const newData = await getDocs(q);
            setEvents(newData.docs.map((doc) =>({...doc.data(), id: doc.id})));
          };
          setInputName("");
          getEvents();
        }else{
          console.log("nameSwitch is false")
          document.getElementById(id+"error").style.display = "block";
        }
      }else{
        document.getElementById(id+"duplicate").style.display = "block";
      }
    }
  }


  const addParticipant = async (id, Attendees, index) =>{
    const eventDoc = doc(db, "StayAndPlay", id)
    let shownName=""
    if(events[index].Max_Participants > Attendees.length){
      if(inputName === ""){
        console.log("Error, no Input");
        document.getElementById(id+"text").style.display = "block";
      }else{
        for(let i=0; i<usersList.length; i++){
          nameCheck = usersList[i].email;
          if(nameCheck === inputName.toLowerCase()){
            console.log("yes, name is " + usersList[i].name);
            nameSwitch=true;
            shownName= usersList[i].name;
          }
        }
        if(!Attendees.includes(shownName)){
          if(nameSwitch===true){
            const newAttendees = {Attendees: [...Attendees, shownName]}
            await updateDoc(eventDoc, newAttendees);
            console.log("no error")
            document.getElementById(id+"text").style.display = "none";
            document.getElementById(id+"error").style.display = "none";
            document.getElementById(id+"duplicate").style.display = "none";
            document.getElementById(id+"success").style.display = "block";
            document.getElementById(id+"input").value = "";
            const getEvents = async () =>{
              const q = query(eventsCollectionRef, where("Date", ">", startOfDay), orderBy("Date", "asc"));
              const newData = await getDocs(q);
              setEvents(newData.docs.map((doc) =>({...doc.data(), id: doc.id})));
            };
            setInputName("");
            getEvents();
  
          }else{
            console.log("nameSwitch is false")
            document.getElementById(id+"error").style.display = "block";
          }
        }else{
          document.getElementById(id+"duplicate").style.display = "block";
        }
      }
    }else{
      document.getElementById(id+"checkFail").style.display = "block";
    }
    
  }


  return (
    <div class="marqueeDiv">
    <div class="mainContent">
      <h1>Upcoming Stay & Play Events</h1>
      <h4>To sign up for an upcoming event <br></br> enter your Email Address and hit "Sign Up"
      <br></br><br></br>If you need to cancel, contact Mike Baumgartner</h4>
      {/* <table>
        <thead>
          <tr>
            <th colSpan={6}>Golf & Game Payment Status</th>
          </tr>
          <tr>
            <th rowSpan={2}>Player Name</th>
            <th>Tuesday</th>
            <th>Wednesday</th>
            <th>Thursday</th>
            <th rowSpan={2}>$ owed for bets</th>
            <th rowSpan={2}>Paid</th>
          </tr>
          <tr>
            <th>EagleSticks</th>
            <th>The Virtues</th>
            <th>Denison</th>
          </tr>
        </thead>
        <tbody>
          {sheet1Data.map((data) => (
            <tr>
              <td>{data._1}</td>
              <td>{data._2}</td>
              <td>{data._3}</td>
              <td>{data._4}</td>
              <td>{data._5}</td>
              <td>{data._6}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <table class="verticalTable">
        <thead>
          <tr>
            <th colSpan={4}>Draft of Schedule of Activities</th>
          </tr>
          <tr>
            <th>Day</th>
            <th>Time</th>
            <th>Location</th>
            <th>Activity</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#68ad84"}}>Tuesday</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#68ad84"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#68ad84"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#68ad84"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", backgroundColor: "#68ad84"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#785992ff"}}>Wednesday</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#785992ff"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#785992ff"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#785992ff"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#785992ff"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#785992ff"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#785992ff"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", backgroundColor: "#785992ff"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#c2b465ff"}}>Thursday</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#c2b465ff"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)", backgroundColor: "#c2b465ff"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", backgroundColor: "#c2b465ff"}}></td>
          </tr>
          <tr>
            {sheet2Data.map((data) => (
              <td height={20}>{data._17}</td>
          ))}
          </tr>
          <tr>
            <td height={20}>Eaglesticks</td>
            <td height={20}>Eaglesticks</td>
            <td height={20} >Courtyard - Newark</td>
            <td height={20}>Newark</td>
            <td height={20}>Courtyard - Newark</td>
            <td height={20}>Courtyard - Newark</td>
            <td height={20}>The Virtues</td>
            <td height={20}>The Virtues</td>
            <td height={20}>The Virtues</td>
            <td height={20}>The Virtues</td>
            <td height={20}>The Virtues</td>
            <td height={20}>Courtyard - Newark</td>
            <td height={20}>Courtyard - Newark</td>
            <td height={20}>Courtyard - Newark</td>
            <td height={20}>Deniuson Golf Club</td>
            <td height={20}>Deniuson Golf Club</td>
            <td height={20}></td>
          </tr>
          <tr>
            {sheet2Data.map((data) => (
              <td height={20}>{data._19}</td>
          ))}
          </tr>
        </tbody>
      </table>
      <table class="verticalTable">
        <thead>
          <tr>
            <th colSpan={8}>Mid-Ohio Groups and Tee-Times</th>
          </tr>
          <tr>
            <th colSpan={2} style={{backgroundColor: "#68ad84"}}>15-Jul</th>
            <th colSpan={4} style={{backgroundColor: "#785992ff"}}>16-Jul</th>
            <th colSpan={2} style={{backgroundColor: "#c2b465ff"}}>17-Jul</th>
          </tr>
          <tr>
            <th>Time</th>
            <th>Eaglesticks</th>
            <th>Time</th>
            <th>The Virtues</th>
            <th>Time</th>
            <th>The Virtues (Scramble)</th>
            <th>Time</th>
            <th>Denison</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>9:39 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>9:48 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>9:57 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>10:06 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>10:15 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
          </tr>
          <tr>
            {sheet3Data.map((data) => (
              <td height={20}>{data._3}</td>
          ))}
          </tr>
          <tr>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>9:30 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>9:40 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>9:50 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>10:00 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>10:10 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
          </tr>
          <tr>
            {sheet3Data.map((data) => (
              <td height={20}>{data._5}</td>
          ))}
          </tr>
          <tr>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>3:30 PM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>3:40 PM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>3:50 PM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>4:00 PM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
          </tr>
          <tr>
            {sheet3Data.map((data) => (
              <td height={20}>{data._7}</td>
          ))}
          </tr>
          <tr>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>9:30 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>9:40 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>9:50 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}>10:00 AM</td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
            <td height={20} style={{fontWeight: "bolder", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)", borderBottomColor: "rgba(0,0,0,0)"}}></td>
            <td height={20} style={{borderTopColor: "rgba(0, 0, 0, 0)"}}></td>
          </tr>
          <tr>
            {sheet3Data.map((data) => (
              <td height={20}>{data._9}</td>
          ))}
          </tr>
        </tbody>
      </table> */}
      <ul class="eventList">
        {events?.map((event, index) => (
            <li key={event.id}>
              <div class="eventDiv">
                <div class="eventHeader">
                  <h2>{event.Name}</h2>
                </div>
                <div class="eventHeader">
                  <h4 class="loc">{event.Location}</h4>
                  <h4>
                    From {new Date(event.Date.seconds * 1000 + event.Date.nanoseconds / 1000000).toDateString()} <br></br> 
                    To {new Date(event.EndDate.seconds * 1000 + event.EndDate.nanoseconds / 1000000).toDateString()}
                  </h4>

                </div>
                <div class="eventContent">
                  <section style={{width: "80%"}}>
                    <h4 style={{textAlign: "left"}}>Additional Notes:</h4>
                    <p>{event.Notes}</p>
                  </section>
                </div>
                <div class="eventContent">
                  <section>
                    <h2>Attendees:</h2>
                    <ol>
                      {event.Attendees.map((attendee, index)=>(
                        <li key={index}>
                          <p>{attendee}</p>
                        </li>
                      ))}
                    </ol>
                    <h2>Waiting List:</h2>
                    <ol>
                      {event.Waiting.map((person, index)=>(
                        <li key={index}>
                          <p>{person}</p>
                        </li>
                      ))}
                    </ol>
                  </section>
                  <div class="attendeeDiv">
                    <section>
                      <p class="attendeeInfo">Number of Attendees: {event.Attendees.length}</p>
                      <p class="attendeeInfo">Spots Remaining Available: {event.Max_Participants - event.Attendees.length}</p>
                      <p class="attendeeInfo">Number on Waiting List: {event.Waiting.length}</p>
                    </section>
                    <section>
                      {(() => {
                      if ((event.Max_Participants > event.Attendees.length)){
                          return (
                            <div class="inputDiv">
                              <input id={event.id+'input'} class="attendeeInput" placeholder="Email Address" onChange={(e) =>{setInputName(e.target.value)}}/>
                                <h3 id={event.id+'text'} style={{display: 'none', margin: '0px', marginBottom: '10px', color: 'red'}}>Please Enter a Name</h3>
                                <h3 id={event.id+'duplicate'} style={{display: 'none', margin: '0px', marginBottom: '10px', color: 'red'}}>Name is already signed up</h3>
                                <h5 id={event.id+'error'} style={{display: 'none', margin: '0px', marginBottom: '10px', color: 'red'}}>The Email entered was not recognized. <br></br>
                                If this was a mistake, contact Mike Baumgartner.</h5>
                              <button id={event.id} onClick={() =>{checkForAdd(event.id, index)}}>Sign Up</button>
                              <h3 id={event.id+'success'} style={{display: 'none', margin: '0px', marginTop: '10px', color: 'blue'}}>Submission Successful!</h3>
                              <h3 id={event.id+'checkFail'} style={{display: 'none', margin: '0px', marginTop: '10px', color: 'blue'}}>This spot has already been filled</h3>
                            </div>
                          )
                        } else{
                        return(
                          <div>
                            <h3 style={{color: 'red', fontSize: '2em'}}>Event is Full</h3>
                            <h3>Join the Waiting List</h3>
                            <div class="inputDiv">
                              <input id={event.id+'input'} class="attendeeInput" placeholder="Email Address" onChange={(e) =>{setInputName(e.target.value)}}/>
                                <h3 id={event.id+'text'} style={{display: 'none', margin: '0px', marginBottom: '10px', color: 'red'}}>Please Enter a Name</h3>
                                <h3 id={event.id+'duplicate'} style={{display: 'none', margin: '0px', marginBottom: '10px', color: 'red'}}>Name is already signed up</h3>
                                <h5 id={event.id+'error'} style={{display: 'none', margin: '0px', marginBottom: '10px', color: 'red'}}>The Email entered was not recognized. <br></br>
                                If this was a mistake, contact Mike Baumgartner.</h5>
                              <button id={event.id} onClick={() =>{checkForWaiting(event.id, index)}}>Join Waiting List</button>
                              <h3 id={event.id+'success'} style={{display: 'none', margin: '0px', marginTop: '10px', color: 'blue'}}>Submission Successful!</h3>
                              <h3 id={event.id+'checkFail'} style={{display: 'none', margin: '0px', marginTop: '10px', color: 'blue'}}>This spot has already been filled</h3>
                            </div>
                          </div>
                          )
                        }
                      })()}
                    </section>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>

    </div>
    </div>
  );
};
  
export default StayAndPlay;